// @flow
import * as React from 'react';
import Checkboxes from 'components/Checkboxes';
import Field from './Field';

const CheckboxesField = ({
  name,
  label,
  description,
  large,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  options: Array<{ label: string, name: string }>,
  large?: boolean
}) => {
  const compare = (pp, np) =>
    props.options
      .map(p => p.name)
      .every(n => pp.getValue(n) === np.getValue(n));
  return (
    <Field
      inputProps={props}
      name={name}
      label={label}
      description={description}
      customCompare={compare}
      renderInput={({ getValue, id, qaId, hasError, updateValueByName }) => (
        <Checkboxes
          id={id}
          name={name}
          getValue={getValue}
          hasError={hasError}
          onChange={updateValueByName}
          data-qa-id={qaId}
          large={large}
          {...props}
        />
      )}
    />
  );
};

export default CheckboxesField;
